import { useEffect, useState } from "react";
/** Persist a JSON-serializable value in localStorage, keyed by `key`. */
export function useLocalStorage(key, initial) {
    const [value, setValue] = useState(() => {
        try {
            const raw = localStorage.getItem(key);
            return raw !== null ? JSON.parse(raw) : initial;
        }
        catch {
            return initial;
        }
    });
    useEffect(() => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        }
        catch {
            /* ignore quota / unavailable storage */
        }
    }, [key, value]);
    return [value, setValue];
}
